import { RISK_ASSESSMENT_REPORT } from '@/pages/reports/ReportPermissions.js';
import BasePolicy from '@/policies/BasePolicy.js';

export default class ReportPolicy extends BasePolicy {
    viewAny(user) {
        return (
            user.hasPermissionTo('view reports') ||
            user.hasGroupPermissionTo('view reports') ||
            user.hasEnrolledPermissionTo('view reports')
        );
    }

    view(user, reportName) {
        if (user.hasPermissionTo('view reports') && user.hasPermissionTo(`view ${reportName}`)) {
            return true;
        }

        if (user.hasGroupPermissionTo('view reports') && user.hasGroupPermissionTo(`view ${reportName}`)) {
            return true;
        }

        if (user.hasEnrolledPermissionTo('view reports') && user.hasEnrolledPermissionTo(`view ${reportName}`)) {
            return true;
        }

        return false;
    }

    viewRiskAssessment(user) {
        if (user.hasPermissionTo('has administrative access for risk assessment report')) {
            return true;
        }

        if (!this.$store.getters['InstitutionSettings/get']('risk_assessment_report_enabled')) {
            return false;
        }

        return (
            user.hasPermissionTo(`view ${RISK_ASSESSMENT_REPORT}`) ||
            user.hasGroupPermissionTo(`view ${RISK_ASSESSMENT_REPORT}`) ||
            user.hasEnrolledPermissionTo(`view ${RISK_ASSESSMENT_REPORT}`)
        );
    }
}
